module.exports = __webpack_public_path__ + "static/media/smartstream.1ccc7763.png";